import React from "react";
import styled from "styled-components";
// import Section from "./Section";

function Contact() {
  return (
    <Wrap>
      <ContactInfo>
        <Logo src="/images/namndX_logo.png" />
        <DetailContact>
          <Title>Contact Me</Title>
          <Detail>Cell Phone: +84 938786679</Detail>
          <Detail>Email: namnips@gmail.com</Detail>
          <Detail>Website: https://nguyendinhnam.netlify.app/</Detail>
        </DetailContact>
      </ContactInfo>
    </Wrap>
  );
}

export default Contact;

const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
`;

const ContactInfo = styled.div`
  width: 90vw;
  margin: 100px auto;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center; // horizontal alignment
  text-align: left;
  background-color: #f2f2f2;
  border-radius: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: start;
  }
`;

const Logo = styled.img`
  width: 25%;
  max-height: 250px;
  max-width: 250px;
  margin-left: 0px;
  padding: 10px;
  background-color: white;
  border-radius: 15px;

  @media (max-width: 768px) {
    width: 60%;
    margin-bottom: 20px;
  }
`;

const DetailContact = styled.div`
  width: 100%;
  margin-left: 30px;
  align-items: top;
`;

const Title = styled.h1`
  margin: 20px 0px;
  font-size: 2rem;
`;

const Detail = styled.p`
  margin: 15px 0px;
  font-size: 1.2rem;
`;
